import React from "react";
import css from "./style.module.css";

function Row({ label, value }) {
  return (
    <div className={css.reviewRow}>
      <div className={css.reviewKey}>{label}</div>
      <div className={css.reviewValue}>{value || <span className="text-muted">—</span>}</div>
    </div>
  );
}

function TagList({ items }) {
  if (!items || !items.length) return <span className="text-muted">—</span>;
  return (
    <div className="d-flex flex-wrap gap-1">
      {items.map((t) => (
        <span key={t} className={css.chip}>{t}</span>
      ))}
    </div>
  );
}

export default function ReviewStep({ values }) {
  return (
    <>
      <h5 className="mb-1">Review</h5>
      <p className="text-muted small mb-4">
        Verify the details below, then submit to create the customer.
      </p>

      <div className={css.reviewSection}>
        <h6>Company</h6>
        <Row label="Company name" value={values.companyName} />
        <Row label="Company domain" value={values.companyDomain} />
        <Row label="Sender email" value={values.senderEmail} />
        <Row label="Logo file" value={values.file ? values.file.name : null} />
      </div>

      <div className={css.reviewSection}>
        <h6>Integrations</h6>
        <Row label="Okta domain" value={values.oktaDomain} />
        <Row label="Okta client ID" value={values.oktaClientID} />
        <Row label="Salesforce username" value={values.sfUsername} />
        <Row label="Salesforce password" value={values.sfPassword ? "••••••••" : null} />
        <Row label="Salesforce security token" value={values.sfSecurityToken ? "••••••••" : null} />
      </div>

      <div className={css.reviewSection}>
        <h6>Marketing seeds</h6>
        <Row label="Document types" value={<TagList items={values.documentTypes} />} />
        <Row label="Media channels" value={<TagList items={values.mediaChannels} />} />
        <Row label="Geographies" value={<TagList items={values.geographies} />} />
        <Row label="Priorities" value={<TagList items={values.priorities} />} />
      </div>
    </>
  );
}
